import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Container = styled.div`
  color: var(--black);
  text-align: center;
  background-color: var(--white);
  height: 100%;
  width: 100%;

  .row-title {
    padding: 130px 158px 0 158px !important;
  }

  .row-section {
    padding: 0 158px 0 158px !important;
  }

  @media only screen and (max-width: 540px) {
    .row-title {
      padding: 130px 52px 0 52px !important;
    }
    .row-section {
      padding: 0 52px 0 52px !important;
    }
  }

  @media only screen and (max-width: 820px) {
    .row-title {
      padding: 130px 74px 0 74px;
    }
    .row-section {
      padding: 0 74px 0 74px;
    }
  }
`

export const Title = styled.h1`
  height: 100%;
  width: 100%;
  font-family: 'Noto Sans Thai';
  line-height: 150px;
  font-size: clamp(30px,9vw, 64px);
  text-align: left;

  @media only screen and (max-width: 820px) {
    line-height: 60px;
  }
`

export const TextSection = styled.p`
  color: var(--black);
  font-family: 'Noto Sans Thai';
  line-height: 35px;
  font-size: clamp(20px, 2.5vw, 24px);
  text-align: left;
  cursor: pointer;

  width: fit-content;
  position: relative;
  text-decoration: none;

  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 4px;
    border-radius: 4px;
    background-color: var(--secondary);
    bottom: -1px;
    left: 0;
    transform-origin: right;
    transform: scaleX(0);
    transition: transform 0.3s ease-in-out;
  }

  &:hover::before {
    transform-origin: left;
    transform: scaleX(1);
  }
`

export const ContainerCooper = styled.div`
  width: 100%;
  height: 100%;
  margin-top: 5%;
  background-color: ${(props) => (props.bg ? props.bg : 'var(--white)')};
  padding: 120px 158px 120px 158px;

  @media only screen and (max-width: 540px) {
    padding: 40px 50px !important;

    .ant-col-14 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-9 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-offset-1 {
      margin-left: 0 !important;
    }
  }

  .col-inter {
    padding-left: 50px;
  }
  @media only screen and (max-width: 414px) {
    .col-inter {
      padding-left: 12px !important;
    }
  }

  @media only screen and (max-width: 1024px) {
    .ant-col-14 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-9 {
      flex: 0 0 100% !important;
      max-width: 100% !important;
    }
    .ant-col-offset-1 {
      margin-left: 0 !important;
    }
  }
`

export const TextHead = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 60px;
  font-size: clamp(40px, 10vw, 60px);
  text-align: left;
  margin-bottom: 20px;

  @media only screen and (max-width: 1024px) {
    margin-top: 20px;
  }
`

export const TextDetail = styled.p`
  font-family: 'Noto Sans Thai';
  line-height: 40px;
  font-size: clamp(18px, 2.5vw, 24px);
  text-align: left;
`

export const Href = styled(Link)`
  color: var(--white);
  width: 100%;
  justify-content: center;
  display: flex;
`

export const TextBottom = styled.div`
  font-family: 'Brevia Light Italic';
  font-size: clamp(40px, 2.5vw, 56px);
  line-height: 50px;
  margin: 0;
  position: absolute;
  left: -2px;
  bottom: -9px;
  color: var(--white);
  text-align: left;
`

export const CardImage = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  padding-bottom: 100%;

  .hover01 {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-transition: 0.3s ease-in-out;
    transition: 0.3s ease-in-out;
  }

  .hover01 :hover {
    -webkit-transform: scale(1.3);
    transform: scale(1.3);
  }
`

export const ContainerCard = styled.div`
  width: 100%;
  border-radius: 20px;
  display: flex;
  justify-content: center;
`
